<div class="system-info">

    <!-- <i class="feather icon-monitor mr-2"></i> {{this.ipaddress}} -->
    <!-- <i class="feather icon-calendar mr-2 ml-4"></i> {{this.date}} -->
    <!-- <i class="feather icon-clock mr-2 ml-4"></i> <span id="clock"></span> -->

</div>
